import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { changePincode } from '../../../AxiosRtk/PinCode';
import SuccessMessage from '../../modals/SuccessMessage';
import useAuthentication from '../../../../customHooks/authentication';

const ChangeEmergencyPincode = ({ setModifyPin, getLangTranslation }) => {
    const { user } = useSelector(({ auth }) => auth);
    const [apiStatus, setApiStatus] = useState(false);
    const [successMsgShow, setSuccessMsgShow] = useState(false);
    const { handleLogout } = useAuthentication();
   
    const closeModal = () => {
        setSuccessMsgShow(false);
        if(window.location.pathname !== '/settings') {
            setModifyPin('');
            handleLogout();
        }
    }
    
    const [pinInput, setPinInput] = useState([
        { name: 'OLD_PIN', value: '', error: '', placeholder: 'Old Pin', label: 'Old PIN Code', type: 'password' },
        { name: 'NEW_PIN', value: '', error: '', placeholder: 'New Pin', label: 'New PIN Code', type: 'password' },
        { name: 'CONFIRM_NEW_PIN', value: '', error: '', placeholder: 'Confirm New Pin', label: 'Confirm PIN Code', type: 'password' },
    ]);



    function handleInputChange(e) {
        const { name, value } = e.target;
        const tempInput = [...pinInput];

        tempInput.forEach((item, index) => {
            if (item?.name === name && value?.length > 4) {
                tempInput[index]['value'] = tempInput[index]?.value
                tempInput[index]['error'] = 'PINCODE_MUST_HAVE_FOUR_DIGIT'
            } else if (item?.name === name) {
                tempInput[index]['value'] = value
                tempInput[index]['error'] = ''
            }
        })

        setPinInput(tempInput);
    }

    function handleDisplayPwd(name) {
        const tempInput = [...pinInput];
        tempInput?.forEach((item, index) => {
            if (item?.name === name) {
                tempInput[index]['type'] = tempInput[index]['type'] === 'password' ? 'text' : 'password'
            }
        })
        setPinInput(tempInput)
    }

    function handlePincodeSaveBtn() {
        const tempInput = [...pinInput];
        let flag = true;
        if (isEmpty(tempInput[0]?.value)) {
            tempInput[0]['error'] = 'OLD_PIN_REQUIRED'
            flag = false
        } else if (tempInput[0]?.value != user?.loginPin) {
            tempInput[0]['error'] = 'OLD_PIN_INCORRECT'
            flag = false
        } else {
            tempInput[0]['error'] = ''
        }

        if (isEmpty(tempInput[1]?.value)) {
            tempInput[1]['error'] = 'NEW_PIN_REQUIRED'
            flag = false
        } else if (tempInput[1]?.value?.length !== 4) {
            tempInput[1]['error'] = 'PINCODE_MUST_HAVE_FOUR_DIGIT'
            flag = false
        } else {
            tempInput[1]['error'] = ''
        }

        if (isEmpty(tempInput[2]?.value)) {
            tempInput[2]['error'] = 'CONFIRM_NEW_PIN_REQUIRED'
            flag = false
        } else if (tempInput[2]?.value !== tempInput[1]?.value) {
            tempInput[2]['error'] = 'NEW_PIN_CONFIRM_PIN_NOT_MATCHING'
            flag = false
        } else {
            tempInput[2]['error'] = ''
        }

        setPinInput(tempInput);
        if (!flag) {
            return;
        }

        const payload = {
            oldPin: pinInput[0]?.value,
            newPin: pinInput[1]?.value
        }
        setApiStatus(true);
        changePincode(payload)
            .then((res) => {
                setSuccessMsgShow(true);
            })
            .catch((err) => {
                console.log("change pincode catch error ==>>", err?.response?.data?.message);
            })
            .finally(() => {
                setApiStatus(false);
            })
    }

    return (
        <>
            <div className="content-550 mx-auto">
                <h5 className="my-6">{getLangTranslation("SETTINGS_PIN_CODE", "Pin Code")}</h5>
                {
                    pinInput?.map((item) => {
                        return (
                            <div className="mb-6" key={item?.name}>
                                <label htmlFor="oldPinCode" className="form-label">{item?.label}</label>
                                <div className="input-group">
                                    <input
                                        type={item?.type}
                                        className="form-control border-end-0"
                                        id={item?.name}
                                        name={item?.name}
                                        placeholder={item?.placeholder}
                                        value={item?.value}
                                        onChange={handleInputChange}
                                    />
                                    <span
                                        className="input-group-text border-start-0 pt-cursor"
                                        onClick={() => handleDisplayPwd(item?.name)}
                                    >
                                        <i className={`fa ${item?.type === 'password' ? 'fa-eye-slash' : 'fa-eye'}`} id="togglePassword"></i>
                                    </span>
                                </div>
                                {item?.error && <label className='field-error'>{getLangTranslation(item?.error)}</label>}
                            </div>
                        )
                    })
                }
                <button 
                    className="btn btn-primary w-100" 
                    type="button" 
                    onClick={handlePincodeSaveBtn}
                    disabled={apiStatus}
                >
                    <span className="btn-upper-case">{getLangTranslation("SAVE", "Save")}</span>
                </button>
            </div>
            <SuccessMessage
                showModal={successMsgShow}
                closeModal={closeModal}
                getLangTranslation={getLangTranslation}
                message='PINCODE_CHANGE_SUCCESS_MSG_TXT'
            />
        </>
    )
}

export default ChangeEmergencyPincode